<template>
  <div>
    <edit-form
      v-model="form"
      :form-path="formPath"
      @cancel="cancel"
      @removeItem="removeItem"
    >
      <template v-slot:additional>
        <v-row dense>
          <v-col cols="6"> <v-spacer /></v-col>
          <v-col cols="6">
            <v-btn dense @click="addNewEl">
              <v-icon left>mdi-plus</v-icon>
              {{ $t('FORM_BUILDER.ADD_NEW_EL') }}</v-btn
            >
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12"> {{ $t('ITEM.VALIDATION_RULES') }}: </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-checkbox
              v-model="form.el.required"
              dense
              hide-details
              :label="$t('ITEM.MANDATORY')"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-switch
              v-model="form.el.params.multiselect"
              hide-details
              dense
              inset
              :label="
                form.el.params.multiselect
                  ? $t('ITEM.MULTISELECT')
                  : $t('ITEM.SINGLESELECT')
              "
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="showName"
              hide-details
              dense
              inset
              :label="$t('FORM_BUILDER.ADD_FIELD_NAME')"
              @change="form.el.name = ''"
            ></v-switch>
          </v-col>
          <v-col v-if="showName" cols="12">
            <v-text-field
              v-model="form.el.name"
              :counter="255"
              :rules="rules.requiredTextLine"
              :label="$t('ITEM.NAME')"
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:buttons>
        <slot name="buttons" />
      </template>
    </edit-form>
  </div>
</template>

<script>
import EditForm from '@/modules/form_builder/components/formsComponents/editForms/EditForm';
import formEditable from '@/modules/_global/mixins/form-editable';
import defaultItem from '@/modules/form_builder/components/mixins/default-item';
import { cloneDeep, isEqual } from 'lodash';
import { requiredTextLine } from '@/modules/_global/variables/rules';

const DEFAULT_FORM = { el: { params: { multiselect: true } } };

export default {
  name: 'MultipleFieldsForm',

  components: {
    EditForm
  },

  mixins: [formEditable, defaultItem],

  data: () => ({
    rules: {
      requiredTextLine
    },
    showName: false,
    formPath: 'modules/form_builder/components/forms/EditLanguagesForm.vue',
    form: cloneDeep(DEFAULT_FORM)
  }),

  created() {
    this.showName = !!this.form.el.name.length;
  },

  methods: {
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.form)) {
        return;
      }

      this.form = {
        ...this.form,
        ...formProps
      };

      if (!this.form.el || !this.form.el.params) {
        this.form.el = { ...this.form.el, ...DEFAULT_FORM.el };
      }

      this.emitter();
    },

    cancel() {
      this.$emit('cancel');
    },

    removeItem(idx) {
      if (this.form.el.items.length >= 2) {
        this.form.el.items.splice(idx, 1);
      }
    },

    addNewEl() {
      this.form.el.items.push(
        this.getDefaultItemWithoutElements(
          this.form.el.type,
          this.form.el.name,
          ''
        )
      );
    }
  }
};
</script>

<style scoped></style>
